import { useEffect, useRef, useState } from "react";
import PetInformation from "../PetInformation";

const StaralizationForm = () => {
  const [value, setValue] = useState(
    "i) The serum is not derived from an animal known or suspected to be infected with a pathogen which causes a notifiable disease to which the animal from which the serum is derived is susceptible according to European Regulations or the Animal Health Regulations of the exporting country; and",
  );
  const [value2, setValue2] = useState(
    "ii) That the serum does not originate from an animal in a premise or region or zone of a country that is subject to official restrictions due to a notifiable disease to which the animals are susceptible according to European or other National Animal Health Regulations.",
  );

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const textareaRef2 = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    adjustHeight();
  }, [value]);
  useEffect(() => {
    adjustHeight2();
  }, [value2]);

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Adjust to content
    }
  };
  const adjustHeight2 = () => {
    if (textareaRef2.current) {
      textareaRef2.current.style.height = "auto"; // Reset height
      textareaRef2.current.style.height = `${textareaRef2.current.scrollHeight}px`; // Adjust to content
    }
  };

  return (
    <div>
      <div>
        <PetInformation />
      </div>
      <p className="font-bold py-2">I hereby certify that, the above-mentioned pet animal is Neutered/Spayed. </p>
      <p className="py-3">Veterinary Provider Information:</p>
      <div className="gap-2 flex  items-center w-full pt-3">
        <p className="text-xs w-[200px]">Doctor's Name</p>
        <input type="text" className="text-sm w-[400px]" />
      </div>
      <div className="gap-2 flex  items-center w-full mt-5">
        <p className="text-xs w-[200px]">Doctor's License Number:</p>
        <input type="text" className="text-sm w-[400px]" />
      </div>
      <div className="flex items-center justify-between pt-4">
        <p>Date</p>
        <p>Veterinarian's Signature</p>
      </div>
      <p className="pt-3 font-bold italic">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};

export default StaralizationForm;
